export default function calculateOutputBasedClinkerEmissions({
  amountOfCementDeliveries,
  cementStockVariations,
  clinkerToCementRatio,
  amountOfClinkerDispatched,
  amountOfClinkerSupplied,
  amountOfClinkerStockVariations,
  emissionFactor
}: {
  amountOfCementDeliveries: number
  cementStockVariations: number
  clinkerToCementRatio: number
  amountOfClinkerDispatched: number
  amountOfClinkerSupplied: number
  amountOfClinkerStockVariations: number
  emissionFactor: number
}) {
  return (
    ((amountOfCementDeliveries - cementStockVariations) * clinkerToCementRatio -
      amountOfClinkerSupplied +
      amountOfClinkerDispatched -
      amountOfClinkerStockVariations) *
    emissionFactor
  )
}
